// src/components/Admin/StatsCard.js
import React from 'react';
import { Card, CardContent, Box, Typography, alpha } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

const StatsCard = ({ title, value, subtitle, trend, trendDirection, icon, onClick, loading }) => {
  const getTrendColor = () => {
    if (!trendDirection) return 'text.secondary';
    return trendDirection === 'up' ? '#22C55E' : '#EF4444';
  };

  const getTrendIcon = () => {
    if (!trendDirection) return null;
    return trendDirection === 'up' ? (
      <TrendingUp sx={{ fontSize: 16, ml: 0.5 }} />
    ) : (
      <TrendingDown sx={{ fontSize: 16, ml: 0.5 }} />
    );
  };

  return (
    <Card
      onClick={onClick}
      sx={{
        borderRadius: '12px',
        border: (theme) => `1px solid ${theme.palette.divider}`,
        boxShadow: 'none',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.3s ease',
        '&:hover': onClick ? {
          boxShadow: (theme) => `0 4px 12px ${alpha(theme.palette.primary.main, 0.1)}`,
          transform: 'translateY(-2px)',
        } : {},
        background: (theme) => theme.palette.background.paper,
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
            {title}
          </Typography>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: (theme) => alpha(theme.palette.primary.main, 0.1),
            }}
          >
            {icon}
          </Box>
        </Box>

        <Typography variant="h4" fontWeight={700} sx={{ mb: 1 }}>
          {loading ? '...' : value}
        </Typography>

        <Box display="flex" alignItems="center">
          <Typography
            variant="caption"
            sx={{
              color: getTrendColor(),
              display: 'flex',
              alignItems: 'center',
              fontWeight: 500,
            }}
          >
            {subtitle}
            {getTrendIcon()}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatsCard;